module.exports = __webpack_public_path__ + "static/img/h-logo.628db46.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/head/h-logo.jpg
// module id = fcMj
// module chunks = 28